import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import { AuthProvider } from "secure/AuthContext"; // Assurez-vous que le chemin est correct
import PrivateRoute from "secure/PrivateRoute"; // Assurez-vous que le chemin est correct

ReactDOM.render(
  <AuthProvider>
    <BrowserRouter>
      <Switch>
        {/* Route publique pour l'authentification */}
        <Route path={`/auth`} component={AuthLayout} />

        {/* Route protégée pour l'administration */}
        <PrivateRoute path={`/admin`}>
          <AdminLayout />
        </PrivateRoute>

        {/* Redirection par défaut */}
        <Redirect from={`/`} to="/admin/dashboard" />
      </Switch>
    </BrowserRouter>
  </AuthProvider>,
  document.getElementById("root")
);
